import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
	headerContainer: {
		marginTop: 8,
	},
	billTo: {
		marginTop: 16,
		paddingBottom: 3,
		fontFamily: 'Helvetica-Oblique',
	},
});

const BillTo = ({ invoice }) => {
	const { t } = useTranslation();
	return (
		<View style={styles.headerContainer}>
			<Text style={styles.billTo}>{t('billTo')}: </Text>
			<Text>{`${invoice.firstName} ${invoice.lastName}`}</Text>
			<Text>{invoice.phone}</Text>
			<Text>{invoice.email}</Text>
		</View>
	);
};

export default BillTo;
